import { UserAccountsContextProvider, UserAccountsModals, UserAccountsPanel } from "@/components/organisms";
import { UserAccountHistory } from "./UserAccountHistory";

export const UserAccounts = () => {
  return (
    <UserAccountsContextProvider>
      <div className="mb-12 flex flex-1 flex-col">
        <UserAccountsPanel />
        <UserAccountsModals />
      </div>
    </UserAccountsContextProvider>
  );
};

UserAccounts.History = UserAccountHistory;
